import { useSelector } from 'react-redux';
import type { AppState } from 'state/state.model';

export function useAppSelector<TResult>(
  sel: (s: AppState) => TResult,
  equalityFn?: (left: TResult, right: TResult) => boolean,
): TResult {
  return useSelector<AppState, TResult>(state => sel(state), equalityFn);
}
